<template>
    <div>
        <v-container style="height: 100%;" pt-7 px-6 ma-0 fluid>
        <v-row no-gutters>
            <v-col>
            <v-card style="border-radius: 20px;" class="white">
                <v-card-title class="header-border pa-0 ma-0">
                <v-row class="ml-0" no-gutters align="start" justify="start" style="width: 0px">
                    <v-col cols="auto">
                        <tabs-cadu
                            :tabs="tabs"
                            :currentTab="currentTab"
                            :borderColor="greenColor"
                            :textColor="greyColor"
                            :textColorActive="greenColor"
                        />
                    </v-col>
                </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="3" class="pb-0" :style="showLine">
                            <LeftNovaUnimed
                                :index="tabIndex"
                                @changeButton="changeIndex"
                            />
                        </v-col>
                        <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-10': 'pb-4'" :style="tabIndex === 2 ? { 'overflow': 'auto' } : {}">
                            <RightNovaUnimed
                                :index="tabIndex"
                                ref="rightNova"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="mx-4" style="border-top: 1px solid #9E9E9E80">
                    <v-col cols="12" class="footer-dados px-8 pb-0" style="min-height: 60px;" v-if="!$vuetify.breakpoint.xs">
                        <v-row>
                            <v-col cols="auto">
                                <button-cadu @click="goToAdminPage" outline :backColor="$vuetify.theme.themes.light.primary1">
                                    VOLTAR
                                </button-cadu>
                            </v-col>

                            <v-row align="center" justify="end">
                                <v-col cols="auto" v-if="tabIndex > 0">
                                  <button-cadu :backColor="$vuetify.theme.themes.light.primary2" @click="stepAnterior">
                                      ANTERIOR
                                  </button-cadu>
                                </v-col>
                                <v-col cols="auto" v-if="tabIndex < 3">
                                    <button-cadu @click="stepProximo" :backColor="$vuetify.theme.themes.light.primary1">
                                        PRÓXIMO
                                    </button-cadu>
                                </v-col>
                                <v-col cols="auto" v-else>
                                    <button-cadu @click="showModalNovaUnimed = true" :backColor="$vuetify.theme.themes.light.primary1">
                                        SALVAR VERSÃO
                                    </button-cadu>
                                </v-col>
                            </v-row>
                        </v-row>
                    </v-col>
                    <v-col v-else>
                        <v-row>
                            <v-col class="mt-4" cols="12" v-if="tabIndex < 3">
                                <button-cadu
                                text="PRÓXIMO"
                                @click="stepProximo"
                                :backColor="$vuetify.theme.themes.light.primary1"
                                block
                                />
                            </v-col>
                            <v-col v-else>
                                <button-cadu
                                text="SALVAR VERSÃO"
                                @click="showModalNovaUnimed = true"
                                :backColor="$vuetify.theme.themes.light.primary1"
                                block
                                />
                            </v-col>
                            <v-col cols="12" v-if="tabIndex > 0">
                                <button-cadu
                                  text="ANTERIOR"
                                  @click="stepAnterior"
                                  :backColor="$vuetify.theme.themes.light.primary2"
                                  block
                                />
                            </v-col>
                            <v-col cols="12">
                                <button-cadu text="VOLTAR" @click="dados()" :outline="true" block />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
            </v-col>
        </v-row>
        </v-container>
        <overlay-loading :value="isLoadingOverlay"/>
        <error-modal
            v-model="error"
            :errObj="errObj"
        />
        <ModalNovaUnimed @closeModal="closeModal" @editarDados="editarDados" v-model="showModalNovaUnimed"/>
    </div>
</template>

<script>
import LeftNovaUnimed from './LeftNovaUnimed'
import RightNovaUnimed from './RightNovaUnimed'
import Unimed from '@/services/Unimed'
import ModalNovaUnimed from './Shared/ModalNovaUnimed'

export default {
  components: {
    RightNovaUnimed,
    LeftNovaUnimed,
    ModalNovaUnimed
  },
  data () {
    return {
      tabs: [
        {
          title: 'Dados Cadastrais',
          value: 'dados',
          disabled: false
        }
      ],
      currentTab: 'dados',
      tabIndex: 0,
      greenColor: this.$vuetify.theme.themes.light.primary1,
      greyColor: '#9E9E9E',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      showError: false,
      role: '',
      tokenBearer: localStorage.getItem('tokenBearer'),
      showModalCancelar: false,
      showButtonCancelar: true,
      codigoUnimedVisualizada: this.unimedId,
      usuario: {},
      codigoMinhaUnimed: null,
      showModalAnexo: false,
      abaAnexo: '',
      showSuccessAnexo: false,
      messageAnexo: 'Documento anexado com sucesso!',
      type: 'add',
      anotherModal: false,
      linhaVertical: {
        'border-right': '1px solid #DEE2E6',
        'height': '100%'
      },
      isLoadingOverlay: false,
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      showModalNovaUnimed: false
    }
  },
  methods: {
    async closeModal () {
      this.showModalNovaUnimed = false
      await this.salvarVersao()
      if (!this.error) {
        this.$router.push('/administracao')
      }
    },
    async editarDados () {
      await this.salvarVersao()
      if (!this.error) {
        this.isLoadingOverlay = true
        await this.editar(this.$idUnimed)
        this.isLoadingOverlay = false
        this.$router.push({ name: 'minhaunimed', params: { idUnimed: this.$idUnimed } })
      }
    },
    async editar (id) {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        await unimed.putStartEdit(id)
      } catch (err) {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.showError = true
      }
    },
    async changeIndex (index) {
      let res = await this.$refs.rightNova.validarCampo()
      if (res) {
        this.tabIndex = index

        const tabName = () => {
          switch (index) {
            case 1:
              return 'Dados Cadastrais'
            case 2:
              return 'Classificação'
            case 3:
              return 'Hierarquia'
            case 4:
              return 'Endereço'
          }
        }
        this.$emit('name', tabName())
      }
    },
    goToAdminPage () {
      this.$router.push('/administracao')
    },
    async stepAnterior () {
      if (this.tabIndex === 0) {
        this.$router.push('/administracao')
      } else {
        this.tabIndex--
        const tabName = () => {
          switch (this.tabIndex + 1) {
            case 1:
              return 'Dados Cadastrais'
            case 2:
              return 'Classificação'
            case 3:
              return 'Hierarquia'
            case 4:
              return 'Endereço'
          }
        }
        this.$emit('name', tabName())
      }
    },
    async stepProximo () {
      this.isLoadingOverlay = true
      try {
        let res = await this.$refs.rightNova.validarCampo()
        if (res) {
          this.tabIndex++
          const tabName = () => {
            switch (this.tabIndex + 1) {
              case 1:
                return 'Dados Cadastrais'
              case 2:
                return 'Classificação'
              case 3:
                return 'Hierarquia'
              case 4:
                return 'Endereço'
            }
          }

          this.$emit('name', tabName())
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.isLoadingOverlay = false
      }
    },
    async salvarVersao () {
      this.isLoadingOverlay = true
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)
      try {
        await unimed.putFinishEdit()
        localStorage.setItem('optionEdit', true)
        this.isLoadingOverlay = false
      } catch (err) {
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        this.showModalNovaUnimed = false
        this.error = true
        this.isLoadingOverlay = false
      }
    }
  },
  computed: {
    showLine () {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.linhaVertical : ''
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #E8E8E8

.header-border
  border-bottom: 2px solid $corBorda
</style>
